export const isCypressE2E = (): boolean => window.Cypress?.env('e2e');
